
export enum AmPm {
	AM = "AM",
	PM = "PM"
}
